import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetSubtypeDPHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { SUBTYPE_DP } from '../../../../../routes/paths';

export const useSubtypeDPDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idSubtypeDP } = useParams();
    const [loading, setLoading] = useState(false);
    const [subtypeDP, setSubtypeDP] = useState<Param>();
    const [subtypeDPHistorical, setSubtypeDPHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idSubtypeDP)) {
            setLoading(true);
            asyncGetParam(idSubtypeDP)
                .then((subtypeDP: any) => {
                    if (!subtypeDP || !subtypeDP.items) navigate(SUBTYPE_DP);
                    setSubtypeDP(subtypeDP?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idSubtypeDP]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetSubtypeDPHistorical(idSubtypeDP)
                .then((resp) => {
                    if (resp) setSubtypeDPHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        subtypeDP,
        subtypeDPHistorical,
        showHistorical,
        setShowHistorical,
    };
};
